import { OperatingMarginValues, OperatingMarginResult } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

export function calculateOperatingMargin(values: OperatingMarginValues, t?: ToolsTranslations['operatingMargin']): OperatingMarginResult {
  const { operatingIncome, revenue } = values;

  if (operatingIncome < 0) {
    return { marginPercent: null, isValid: false, message: t?.invalid.operatingIncome ?? 'Rörelseresultat måste vara 0 eller mer' };
  }
  if (revenue <= 0) {
    return { marginPercent: null, isValid: false, message: t?.invalid.revenue ?? 'Omsättning måste vara större än 0' };
  }

  const percent = (operatingIncome / revenue) * 100;
  const marginPercent = Math.round(percent * 100) / 100;
  if (!isFinite(marginPercent)) {
    return { marginPercent: null, isValid: false, message: t?.invalid.generic ?? 'Ogiltiga värden' };
  }
  return { marginPercent, isValid: true };
}


